import React, { useState } from "react"
import { Button, Card, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"
import CardBody from "reactstrap/lib/CardBody/"
import { postEndGame, postResult } from "../../api"
import styles from "./ScoreCounter.module.scss"
import ScoreViewer from "./ScoreViewer/"

const ScoreCounterOnlyPoints = ({ onLeave, setLoading }) => {
	const homeTeam = JSON.parse(localStorage.getItem("homeTeam") ?? "{}")
	const awayTeam = JSON.parse(localStorage.getItem("awayTeam") ?? "{}")
	const [isOpen, setIsOpen] = useState(false)

	const onDone = () => {
		const game = JSON.parse(localStorage.getItem("gameDetails") ?? "{}").gameId
		const sport = localStorage.getItem("sport")
		postResult({
			sport,
			game,
			result: {
				homeScore: JSON.parse(localStorage.getItem("score-homeTeam") ?? 0),
				awayScore: JSON.parse(localStorage.getItem("score-awayTeam") ?? 0),
			},
		}).then(({ error, offline }) => {
			if (!error && !offline)
				postEndGame({ game, sport }).then(({ error, offline }) => {
					if (!error && !offline) onLeave(true)
					else setLoading(false)
				})
			else setLoading(false)
		})
		setLoading(true)
	}

	return (
		<Card>
			<CardBody>
				<h1 className="text-center m-2">{localStorage.getItem("sport")}</h1>

				<div className={styles.wrapper}>
					<div className={styles.alignText}>
						<h3>{`${homeTeam.name} ${homeTeam.surname ?? ""}`}</h3>
					</div>
					<div className={styles.columnFlex}>
						<ScoreViewer />
					</div>
					<div className={styles.alignText}>
						<h3>{`${awayTeam.name} ${awayTeam.surname ?? ""}`}</h3>
					</div>
				</div>
				<Button.Ripple
					color="primary"
					outline
					className="mb-1"
					style={{ margin: "2em auto", display: "block" }}
					onClick={() => setIsOpen(true)}
				>
					Spremi utakmicu
				</Button.Ripple>
			</CardBody>
			<Modal
				isOpen={isOpen}
				toggle={() => setIsOpen(false)}
				className="modal-dialog-centered"
			>
				<ModalHeader toggle={() => setIsOpen(false)}>
					Jesi li siguran?
				</ModalHeader>
				<ModalBody>
					<br />
					<h3>
						{(localStorage.getItem("score-homeTeam") ?? 0) ===
							localStorage.getItem("score-awayTeam") ?? 0
							? "Izjednačeno je"
							: (localStorage.getItem("score-homeTeam") ?? 0) >
									localStorage.getItem("score-awayTeam") ?? 0
							? `Pobjednik je ${homeTeam.name} ${
									homeTeam.surname ?? ""
							  }`
							: `Pobjednik je ${awayTeam.name} ${
									awayTeam.surname ?? ""
							  }`}
					</h3>
					<p>
						{"Rezultat je "}
						{localStorage.getItem("score-homeTeam") ?? 0}-
						{localStorage.getItem("score-awayTeam") ?? 0}
					</p>
					<br />
					<p>
						Jel to točno?{" "}
						<span style={{ color: "red" }}>
							Ovo se nemože poništiti.
						</span>
					</p>
				</ModalBody>
				<ModalFooter>
					<Button.Ripple color="primary" outline onClick={onDone}>
						Spremi i izađi iz utakmice
					</Button.Ripple>
					<Button.Ripple
						color="secondary"
						onClick={() => setIsOpen(false)}
					>
						Odustani
					</Button.Ripple>
				</ModalFooter>
			</Modal>
		</Card>
	)
}

export default ScoreCounterOnlyPoints
